<template>
    <div>
            <top-navbar></top-navbar>
    
    
            <div class="mb-5  background_color" >
              <h6 class="manage-boder pt-2 font1  decoration"><router-link class="decoration" to="/"> Home </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" > Vehicle Sales </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/svehiclesalesreceipt/index">Manage Vehicle Receipts </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>Create Receipt </h6>
                <!-- <h6 class="custom-maintitle mb-2"><b>Create Customer </b></h6> -->
                <div  class="container-fluid ">
                <div class="card bdr-rad2 mt-1 shadow p-2 ">
                <div class="card-body">


  



   

                    <form @submit.prevent="SaveAlldata()" >


<div class="row">


    <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Sales Order</label>
            <v-select class="font-size_def" label="label"    v-model="all_data.so_code"   :disabled="true"></v-select >
           
    </div>
  </div>
    <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Customer</label>
            <v-select class="font-size_def" label="label"    v-model="all_data.user_full_name"  :disabled="true"></v-select>
           
    </div>
  </div>
    <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Invoice</label>
            <v-select class="font-size_def" label="label"    v-model="all_data.invoice_num"  :disabled="true" ></v-select>
           
    </div>
  </div>
    <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Payment Mode</label>
            <v-select class="font-size_def" label="label" @input="LoadMode()"   v-model="all_data.payment_mode"  :options="paymode" ></v-select>
           
    </div>
  </div>

</div>
<div class="row">


    <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Receipt Date</label>
            <input  v-model="all_data.receipt_date" type="date"  style="font-size: small;" class="form-control" required>
           
    </div>
  </div>
    <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Paid Amount</label>
            <input  @input="paidamount()" v-model="all_data.paid_amount"  style="font-size: small;" class="form-control" required>
           
    </div>
  </div>
    <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Bank</label>
            <v-select class="font-size_def" label="bank_name"    v-model="all_data.bank"  :options="banks" ></v-select>
           
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Bank Slip Image</label>
            <input  type="file"  style="font-size: small;" class="form-control">
           
    </div>
  </div>

</div>


<div v-if="chequ" class="row">


<div class="col-md-3">
<div class="form-group required">
        <label class="custom-label" style="font-size: small;">Bank Code</label>
        <input  v-model="all_data.bank_code"  style="font-size: small;" class="form-control" required>
       
</div>
</div>
<div class="col-md-3">
<div class="form-group required">
        <label class="custom-label" style="font-size: small;">Branch Code</label>
        <input  v-model="all_data.branch_code"  style="font-size: small;" class="form-control" required>
       
</div>
</div>


</div>
<div class="row"  v-if="chequ">


<div class="col-md-3">
<div class="form-group required">
        <label class="custom-label" style="font-size: small;">Cheque Date</label>
        <input  v-model="all_data.cheque_date" type="date"  style="font-size: small;" class="form-control" required>
       
</div>
</div>
<div class="col-md-3">
<div class="form-group required">
        <label class="custom-label" style="font-size: small;">Cheque No</label>
        <input  v-model="all_data.cheque_no"  style="font-size: small;" class="form-control" required>
       
</div>
</div>
<div class="col-md-3">
<div class="form-group required">
        <label class="custom-label" style="font-size: small;">Realised Amount</label>
        <input  v-model="all_data.realised_amount"  style="font-size: small;" class="form-control" required>
       
</div>
</div>
<div class="col-md-3">
<div class="form-group required">
        <label class="custom-label" style="font-size: small;">Realised Date</label>
        <input  v-model="all_data.realised_date"  type="date" style="font-size: small;" class="form-control" required>
       
</div>
</div>


</div>
<div class="row">


<div class="col-md-3">
<div class="form-group required">
        <label class="custom-label" style="font-size: small;">Invoice Balance</label>
        <input  v-model="all_data.invoice_amount"  style="font-size: small;" class="form-control" disabled>
       
</div>
</div>
<div class="col-md-3">
<div class="form-group required">
        <label class="custom-label" style="font-size: small;">Additional Charges</label>
        <input  v-model="all_data.additional_charges"  style="font-size: small;" class="form-control" disabled>
       
</div>
</div>
<div class="col-md-3">
<div class="form-group required">
        <label class="custom-label" style="font-size: small;">Balance To Pay</label>
        <input   v-model="all_data.balance_to_pay"  style="font-size: small;" class="form-control" disabled required>
       
</div>
</div>
<div class="col-md-3">
<div class="form-group required">
        <label class="custom-label" style="font-size: small;">Remarks</label>
     
        <textarea v-model="all_data.remarks" class="form-control" rows="2"></textarea>
       
</div>
</div>


</div>
































    

    <div style="border-bottom: 0px; padding-top: 0px; " class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
        <button  type="submit" class="mr-1 btn btn-outline-primary  mb-1 font-size_def bdr-rad">Create</button>
    </div>
    </div>
    <br><br>


</form>




                </div>
                </div>
                <br><br>
              </div> 
            </div>
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    
    </template>
    <script src="/js/vue-select/vue-select.js"> </script>
    <script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/vue/1.0.13/vue.min.js"></script>

  
 



    <script>
      import vSelect from 'vue-select';
      import 'vue-select/dist/vue-select.css';
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
     
    
    
      export default {

        mounted(){
    this.loadAlldata();
  
      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            'id':this.$route.query.id,
            count: 0,
        total:{},
        selectedOption: null, // Store the selected option
        
        gpmrg_total:"0.00",
        gpMrgPre_total:"0.00",
        final_total:"0.00",
        qty:0,
        selectedAccessories: [],
        brokerShow:false,
        mcustomers:[],
        mproducts:[],
        engines:[],
        banks:[],
        contacts:[],
      salespeoples:[

      ],
      subtotal:{},
      errors: {},
      discount:0,
      squatation:{},
        customer:{},
        quotation:{
          'validity_period':{
            label: 'Select Validity Period', value: ''
          },
          'payment_method':{
            label: 'Cash', value: 'Cash'
          },
          'remarks':'',
          'special_discount':0.00,
        },
        sales:{},
      
        // Brands:[],
        all_reps:[],
        engins:[],
        all_data:{},
        details:[],
        chequ:true,

        paymode: [
            { label: 'Select Validity Period', value: '' },
            { label: 'Cash', value: 'Cash' },
            { label: 'Cheque', value: 'Cheque' },
            { label: 'Online Transfer', value: 'Online Transfer' },
          
           
        ],
        variants: ['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'dark','mycoolor'],
        headerBgVariant: 'mycoolor',
        headerTextVariant: 'light',
           
          }
    
        },
        components :{
          'v-select': vSelect,
            ContentFooter,
            TopNavbar,
           
        },
    

        methods : {

          async paidamount() {
          //   alert(this.all_data.invoice_amount + this.all_data.additional_charges);
          //  alert(this.all_data.invoice_amount );
          //  alert( this.all_data.additional_charges);
        const balnce_pay = this.all_data.invoice_amount + this.all_data.additional_charges - this.all_data.paid_amount;

        this.all_data.balance_to_pay = balnce_pay;


       
     },

    

      async LoadMode() {
           
           if(this.all_data.payment_mode['value']=="Cash"){
            this.chequ = false;
           }else if(this.all_data.payment_mode['value']=="Cheque"){
          
             this.chequ = true;
           }
     },
    async loadAlldata() {
       
     
       try {
         const { data} = await  axios.get('/svehiclesalesreceipt/loaddata?id='+this.id,{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          this.all_data = data.all_data;
          this.banks = data.banks;
          // this.details = data.details;
          // this.total = data.total;
          // this.subtotal = data.total- this.discount;
       
         
       } catch (error) {
         console.log(error.response);
       }
      
       if (this.paymode.length > 0) {;
        
        this.all_data.payment_mode = this.paymode[0]['label'];
      }

     },

     async SaveAlldata() {
       
     
       try {
         const { data} = await  axios.post('/svehiclesalesreceipt/create',{userid:this.userid,id:this.id,all_data:this.all_data},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          if(data.status==200){
          this.$router.push('/svehiclesalesreceipt/index');
        }
       
         
       } catch (error) {
         console.log(error.response);
       }



     },

    
       
     
       
   

     

    

    

    
       

        add: function(){
            this.count++;
            this.detail.push({
             
            },)
           
        },

  remove: function () {
            this.count--;
            this.detail.splice({
              
            },1)
            
        },

    },
    
    }
    
    </script>

    <style scoped>
    .button-link {
  display: inline-block;
  padding: 5px 10px;
  font-size: small;
  text-decoration: none;
  color: #3899ea;
 
 
  
  cursor: pointer;
}

.button-link:hover {
  color: black;
  text-decoration: underline;
}
      /* @import "vue-select/dist/vue-select.css"; */
/* .vs__dropdown-option--disabled {
    display: block;
} */
    </style>
    